G.TreasureHunt = G.TreasureHunt || {};

// config:
// tutorial
// collectedGems
// noFriends
// scrollToFriends



// TODO: abstract to PageScroller 
G.TreasureHunt.TreasureHuntWindowPanel = function(config) {
  // imports
  var PageScroller = G.CommonObjects.PageScroller;

  Phaser.Group.call(this, game);

  this.arrowsContainer = game.add.group(this);

  this.pageScroller = new PageScroller({
    width: 500,
    height: 100,
    pageWidth: 550,
    dragThreshold: 0.3,
  });
  this.add(this.pageScroller);

  this.init(config);
};

G.TreasureHunt.TreasureHuntWindowPanel.prototype = Object.create(Phaser.Group.prototype);

G.TreasureHunt.TreasureHuntWindowPanel.prototype.init = function(config) {
  // imports
  var treasureHuntMgr = G.TreasureHunt.treasureHuntMgr;
  var TreasureHuntProgressionPanel = G.TreasureHunt.TreasureHuntProgressionPanel;

  var progressData;

  // if event is ready to start
  // dont show that - we need to show zeros on progress
  if (!treasureHuntMgr.isEventReadyToStart()) {
    progressData = treasureHuntMgr.getProgressData();
  }

  var eventInfo = treasureHuntMgr.getGeneralEventInfo();

  var progressionPanel = createProgressPanel();
  this.pageScroller.addPage(progressionPanel);

  function createProgressPanel() {
    var gemsCollectedDuringLevel = config.collectedGems || 0;

    var value = 0;
    var targetValue = 0;
    var target = eventInfo.gemsTarget;

    if (progressData) {
      value = progressData.gemsCollected - gemsCollectedDuringLevel;
      targetValue = progressData.gemsCollected;
      target = progressData.gemsTarget;
      if (value !== targetValue) {
        game.time.events.add(1000, function() {
          if (progressionPanel.game === null) return;
          progressionPanel.showProgress();
        });
      }
    }

    var panelConfig = {
      tutorial: config.tutorial || false,
      value: value,
      valueTarget: targetValue,
      target: target,
      sounds: {
        onIncrease: G.sfx.pop,
        onComplete: G.sfx.match_5,
      }
    };

    return new TreasureHuntProgressionPanel(panelConfig);
  };

};
